import { render, staticRenderFns } from "./usersOpeningBalance.vue?vue&type=template&id=b550866c&scoped=true&"
import script from "./usersOpeningBalance.vue?vue&type=script&lang=js&"
export * from "./usersOpeningBalance.vue?vue&type=script&lang=js&"
import style0 from "./usersOpeningBalance.vue?vue&type=style&index=0&id=b550866c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b550866c",
  null
  
)

export default component.exports